import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, catchError, map, Observable, of } from 'rxjs';
import { IConfig } from './IConfig';
export const configurationFactory = (config: ConfigurationService): (() => Observable<boolean>) => {
  return () => config.loadAppConfig();
};

@Injectable({
  providedIn: 'root',
})
export class ConfigurationService {
  config!: IConfig;
  // keep track of config, initialize with fall back Config
  configBeh: BehaviorSubject<IConfig> = new BehaviorSubject<IConfig>(this.config as IConfig);
  config$: Observable<IConfig> = this.configBeh.asObservable();

  constructor(private http: HttpClient) {}

  private createConfig(config: any): IConfig {
    // cast all keys as are
    return { ...(<IConfig>config) };
  }
  // return observable, right now just http.get
  loadAppConfig(): Observable<boolean> {
    // @ts-ignore
    return this.http.get('/assets/environment.json').pipe(
      map((response) => {
        // do something to reflect into local model
        this.config = this.createConfig(response);
        console.log(this.config);
        return true;
      }),
      catchError((error) => {
        console.error('error loading config', error);
        // if in error, return fall back from Config

        return of(false);
      }),
    );
  }
}
